import React from 'react';
import { Sliders } from 'lucide-react';
import { Button } from '../../../../../../../components/common/Button';

const SettingsTab = ({ visibilityState, onVisibilityChange }) => {
  const handleSliderChange = (key, value) => {
    onVisibilityChange({
      ...visibilityState,
      [key]: value
    });
  };

  return (
    <div className="space-y-6">
      <h3 className="text-white font-medium">Map Settings</h3>
      
      {/* Route Display */}
      <div className="space-y-4">
        <h4 className="text-gray-300">Route Display</h4>
        
        <div className="space-y-2">
          <label className="block text-sm text-gray-400">Line Width</label>
          <div className="flex items-center gap-2">
            <input
              type="range"
              min="1"
              max="10"
              value={visibilityState.lineWidth || 4}
              onChange={(e) => handleSliderChange('lineWidth', parseInt(e.target.value))}
              className="w-full"
            />
            <span className="text-sm text-gray-400 w-8">{visibilityState.lineWidth || 4}px</span>
          </div>
        </div>
        
        <div className="space-y-2">
          <label className="block text-sm text-gray-400">Line Opacity</label>
          <div className="flex items-center gap-2">
            <input
              type="range"
              min="10"
              max="100"
              value={(visibilityState.lineOpacity || 0.8) * 100}
              onChange={(e) => handleSliderChange('lineOpacity', parseInt(e.target.value) / 100)}
              className="w-full"
            />
            <span className="text-sm text-gray-400 w-8">{Math.round((visibilityState.lineOpacity || 0.8) * 100)}%</span>
          </div>
        </div>
      </div>
      
      {/* POI Display */}
      <div className="space-y-4">
        <h4 className="text-gray-300">POI Display</h4>
        
        <div className="space-y-2">
          <label className="block text-sm text-gray-400">POI Size by Zoom Level</label>
          
          <div className="space-y-4">
            <div>
              <div className="flex justify-between text-xs text-gray-400 mb-1">
                <span>Far (Zoom 1-7)</span>
              </div>
              <div className="flex items-center gap-2">
                <input
                  type="range"
                  min="8"
                  max="32"
                  value={visibilityState.poiSizeFar || 16}
                  onChange={(e) => handleSliderChange('poiSizeFar', parseInt(e.target.value))}
                  className="w-full"
                />
                <span className="text-sm text-gray-400 w-8">{visibilityState.poiSizeFar || 16}px</span>
              </div>
            </div>
            
            <div>
              <div className="flex justify-between text-xs text-gray-400 mb-1">
                <span>Medium (Zoom 8-14)</span>
              </div>
              <div className="flex items-center gap-2">
                <input
                  type="range"
                  min="12"
                  max="48"
                  value={visibilityState.poiSizeMedium || 24}
                  onChange={(e) => handleSliderChange('poiSizeMedium', parseInt(e.target.value))}
                  className="w-full"
                />
                <span className="text-sm text-gray-400 w-8">{visibilityState.poiSizeMedium || 24}px</span>
              </div>
            </div>
            
            <div>
              <div className="flex justify-between text-xs text-gray-400 mb-1">
                <span>Close (Zoom 15+)</span>
              </div>
              <div className="flex items-center gap-2">
                <input
                  type="range"
                  min="16"
                  max="64"
                  value={visibilityState.poiSizeClose || 32}
                  onChange={(e) => handleSliderChange('poiSizeClose', parseInt(e.target.value))}
                  className="w-full"
                />
                <span className="text-sm text-gray-400 w-8">{visibilityState.poiSizeClose || 32}px</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsTab;